<template>
    <div class="start-div">
        <NavBarLight :showRight="right" :showLeft="left" @toggleArrow="switchArrow()"></NavBarLight>
        <div class="dashboard-content-learning">
            <div class="text-left">
                <div v-if="right" class="right-check">
                    <div class="row" id="content-row">
                        <transition name="slide-fade">  
                            <div class="col-sm-3" id="category-table-modern-js">
                                <div class="table-outline">
                                    <div v-if="slug === 'modern-javascript'">
                                        <div v-for="(titles, slug) in courses.modern_javascript" :key="slug">
                                            <div class="chapter-group" @click="showTab(slug)">
                                                <span v-if="topicCompletedJSArr['modern-javascript-' + slug] === 'true'">
                                                    <img src="../assets/tick.svg" class="completed-tick"/>
                                                </span>
                                                <span v-else>
                                                    <img src="../assets/tick-grey.svg" class="not-completed-tick"/>
                                                </span>
                                                
                                                <span>
                                                    {{titles.title}}
                                                </span>
                                                
                                                <i class="fa fa-caret-right"></i>  
                                                
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else-if="slug === 'react'">
                                        <div v-for="(titles, slug) in courses.react" :key="slug">
                                            <div class="chapter-group" @click="showTab(slug)">
                                                <span v-if="topicCompletedReactArr['react-' + slug] === 'true'">
                                                    <img src="../assets/tick.svg" class="completed-tick"/>
                                                </span>
                                                <span v-else>
                                                    <img src="../assets/tick-grey.svg" class="not-completed-tick"/>
                                                </span>
                                                
                                                <span>
                                                    {{titles.title}}
                                                </span>
                                                
                                                <i class="fa fa-caret-right"></i>  
                                                
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else-if="slug === 'react-native'">
                                        <div v-for="(titles, slug) in courses.react_native" :key="slug">
                                            <div class="chapter-group" @click="showTab(slug)">
                                                <span v-if="topicCompletedRNArr['react-native-' + slug] === 'true'">
                                                    <img src="../assets/tick.svg" class="completed-tick"/>
                                                </span>
                                                <span v-else>
                                                    <img src="../assets/tick-grey.svg" class="not-completed-tick"/>
                                                </span>
                                                
                                                <span>
                                                    {{titles.title}}
                                                </span>
                                                
                                                <i class="fa fa-caret-right"></i>  
                                                
                                            </div>
                                        </div>
                                    </div>


                                    <div v-else-if="slug === 'ui-design'">
                                        <div v-for="(titles, slug) in courses.ui_design" :key="slug">
                                            <div class="chapter-group" @click="showTab(slug)">
                                                <span v-if="topicCompletedUIArr['ui-design-' + slug] === 'true'">
                                                    <img src="../assets/tick.svg" class="completed-tick"/>
                                                </span>
                                                <span v-else>
                                                    <img src="../assets/tick-grey.svg" class="not-completed-tick"/>
                                                </span>
                                                
                                                <span>
                                                    {{titles.title}}
                                                </span>
                                                
                                                <i class="fa fa-caret-right"></i>  
                                                
                                            </div>
                                        </div>
                                    </div>


                                    <div v-else-if="slug === 'vue'">
                                        <div v-for="(titles, slug) in courses.vue" :key="slug">
                                            <div class="chapter-group" @click="showTab(slug)">
                                                <span v-if="topicCompletedVueArr['vue-' + slug] === 'true'">
                                                    <img src="../assets/tick.svg" class="completed-tick"/>
                                                </span>
                                                <span v-else>
                                                    <img src="../assets/tick-grey.svg" class="not-completed-tick"/>
                                                </span>
                                                
                                                <span>
                                                    {{titles.title}}
                                                </span>
                                                
                                                <i class="fa fa-caret-right"></i>  
                                                
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </transition>
                        <div class="col-sm-9">
                            <div class="content">
                                <div v-if="slug === 'modern-javascript'">
                                    <div v-for="(titles, topic_slug) in courses.modern_javascript" :key="topic_slug">
                                        <div v-if="topic === topic_slug">
                                            <h1 class="category-heading">
                                                {{titles.title}}
                                            </h1>
                                            <br>
                                            <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="slug === 'react'">
                                    <div v-for="(titles, topic_slug) in courses.react" :key="topic_slug">
                                        <div v-if="topic === topic_slug">
                                            <h1 class="category-heading">
                                                {{titles.title}}
                                            </h1>
                                            <br> 
                                            <ContentComponent :topic="topic_slug" :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="slug === 'react-native'">
                                    <div v-for="(titles, topic_slug) in courses.react_native" :key="topic_slug">
                                        <div v-if="topic === topic_slug">
                                            <h1 class="category-heading">
                                                {{titles.title}}
                                            </h1>
                                            <br> 
                                            <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="slug === 'ui-design'">
                                    <div v-for="(titles, topic_slug) in courses.ui_design" :key="topic_slug">
                                        <div v-if="topic === topic_slug">
                                            <h1 class="category-heading">
                                                {{titles.title}}
                                            </h1>
                                            <br> 
                                            <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="slug === 'vue'">
                                    <div v-for="(titles, topic_slug) in courses.vue" :key="topic_slug">
                                        <div v-if="topic === topic_slug">
                                            <h1 class="category-heading">
                                                {{titles.title}}
                                            </h1>
                                            <br> 
                                            <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="col-sm-12">
                    <div class="content">
                        <div v-if="slug === 'modern-javascript'">
                            <div v-for="(titles, topic_slug) in courses.modern_javascript" :key="topic_slug">
                                <div v-if="topic === topic_slug">
                                    <h1 class="category-heading">
                                        {{titles.title}}
                                    </h1>
                                    <br>
                                    <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                </div>
                            </div>
                        </div>

                        <div v-if="slug === 'react'">
                            <div v-for="(titles, topic_slug) in courses.react" :key="topic_slug">
                                <div v-if="topic === topic_slug">
                                    <h1 class="category-heading">
                                        {{titles.title}}
                                    </h1>
                                    <br> 
                                    <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                </div>
                            </div>
                        </div>

                        <div v-if="slug === 'react-native'">
                            <div v-for="(titles, topic_slug) in courses.react_native" :key="topic_slug">
                                <div v-if="topic === topic_slug">
                                    <h1 class="category-heading">
                                        {{titles.title}}
                                    </h1>
                                    <br> 
                                    <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                </div>
                            </div>
                        </div>

                        <div v-if="slug === 'ui-design'">
                            <div v-for="(titles, topic_slug) in courses.ui_design" :key="topic_slug">
                                <div v-if="topic === topic_slug">
                                    <h1 class="category-heading">
                                        {{titles.title}}
                                    </h1>
                                    <br> 
                                    <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                </div>
                            </div>
                        </div>

                        <div v-if="slug === 'vue'">
                            <div v-for="(titles, topic_slug) in courses.vue" :key="topic_slug">
                                <div v-if="topic === topic_slug">
                                    <h1 class="category-heading">
                                        {{titles.title}}
                                    </h1>
                                    <br> 
                                    <ContentComponent :content="titles.data" @next="goToNextTopic"></ContentComponent>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                    
            </div>


        </div>
        
    </div>
</template>



<script>
import Vue from 'vue' 
import NavBarLight from '../components/NavBarLight.vue'
import firebase from '../services/firebase'
import {codemirror} from 'vue-codemirror'
import PurpleButton from '../components/PurpleButton.vue'
import EmbeddedQuiz from '../components/EmbeddedQuiz.vue'
import TextComponent from '../components/TextComponent.vue'
import QuizComponent from '../components/QuizComponent.vue'
import ContentComponent from '../components/ContentComponent.vue'
import lottie from 'vue-lottie'
import * as animationData from '../assets/animations/1127-success.json'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
// theme css
import 'codemirror/theme/base16-dark.css'
import _ from 'lodash'
import ModernJavaScript from '../content/courses/modern-javascript.json'
import React from '../content/courses/react.json'
import ReactNative from '../content/courses/react-native.json'
import UIDesign from '../content/courses/ui-design.json'
import VueJS from '../content/courses/vue.json'

export default {
    name: 'StartLearning',
    components: {
        lottie,
        NavBarLight,
        codemirror,
        PurpleButton,
        EmbeddedQuiz,
        TextComponent,
        QuizComponent,
        ContentComponent
    },
    firebase: {
        quizReactJSX: firebase.database().ref('quizzes/react/jsx'),
        quizReactComponents: firebase.database().ref('quizzes/react/components'),
        quizReactState: firebase.database().ref('quizzes/react/state'),
        quizReactEvents: firebase.database().ref('quizzes/react/events'),
        quizReactConditionalRendering: firebase.database().ref('quizzes/react/conditional-rendering'),
        quizReactKeys: firebase.database().ref('quizzes/react/keys'),
        quizReactRouting: firebase.database().ref('quizzes/react/routing'),
        quizRNIntro: firebase.database().ref('quizzes/react-native/intro'),
        quizRNJSX: firebase.database().ref('quizzes/react-native/jsx'),
        quizRNComponents: firebase.database().ref('quizzes/react-native/components'),
        quizRNView: firebase.database().ref('quizzes/react-native/view-text-and-image'),
        quizRNStyle: firebase.database().ref('quizzes/react-native/style-and-flexbox'),
        quizRNScrollview: firebase.database().ref('quizzes/react-native/scrollview-and-listviews'),
        quizRNNetworking: firebase.database().ref('quizzes/react-native/networking')
    },
    data: function() {
        return {
            showDefault: true,
            right: true,
            left: false,
            defaultOptions: {
                animationData: animationData.default,
                loop: false,
                autoplay: true
            },
            courses: {
                modern_javascript: null,
                react: null,
                react_native: null,
                ui_design: null,
                vue: null
            },
            feedbackUIrating: 0,
            feedbackUItext: '',
            feedbackReactrating: 0,
            feedbackReacttext: '',
            feedbackRNrating: 0,
            feedbackRNtext: '',
            animationSpeed: 1,
            hide: true,
            showFeedback: false,
            slug: this.$route.params.slug,
            topic: this.$route.params.topic,
            topicCompletedReactArr: {
                'react-intro-to-react': "false",
                'react-components': "false",
                'react-state-and-lifecycle-methods': "false",
                'react-events': "false",
                'react-challenge-1': "false",
                'react-conditional-rendering': "false",
                'react-challenge-2': "false",
                'react-keys-and-lists': "false",
                'react-routing': "false",
                'react-real-world-example-1': "false",
                'react-real-world-example-2': "false",
                'react-real-world-example-3': "false",
                'react-real-world-example-4': "false",
                'react-real-world-example-5': "false"

            },
            topicCompletedRNArr: {
                'react-native-intro-to-react-native': "false",
                'react-native-jsx-props-and-state': "false",
                'react-native-components-and-apis': "false",
                'react-native-view-text-and-image': "false",
                'react-native-style-and-flexbox': "false",
                'react-native-scrollview-and-listviews': "false",
                'react-native-networking-apis': "false",
                'react-native-routing': "false",
                'react-native-real-world-example-1': "false",
                'react-native-real-world-example-2': "false",
                'react-native-real-world-example-3': "false",
                'react-native-real-world-example-4': "false",
                'react-native-real-world-example-5': "false"

            },
            topicCompletedUIArr: {
                'ui-design-intro-to-ui-design': "false",
                'ui-design-simplicity-over-complexity': "false",
                'ui-design-outcomes-over-features': "false",
                'ui-design-visual-hierarchy': "false",
                'ui-design-alignment': "false",
                'ui-design-focal-points': "false",
                'ui-design-contrast': "false",
                'ui-design-dominance': "false",
                'ui-design-rythm': "false"
            },
            topicCompletedJSArr: {
                'modern-javascript-intro-to-modern-js': "false",
                'modern-javascript-basic-concepts': "false",
                'modern-javascript-data-types': "false"
            },
            topicCompletedVueArr: {
                'vue-intro-to-vue': "false",
                'vue-components-and-props': "false",
                'vue-directives': "false"
            },
            err: '',
            codeRN: {},
            showQuiz: false,
            quizFBObj: [],
            topicCompleted: false,
            topicQuizScore: 0,
            nextTopicTable: {},
            quizObj: [
                {
                    code: '',
                    question: 'What is the value of this crap?',
                    answer: 'It is zis',
                    options: [
                        'It is zis',
                        'It ees thias',
                        'Tobias Mattei',
                        'Lanus Torvalds'
                    ]
                },
                {
                   code: '',
                    question: 'Crap number 2?',
                    answer: 'It is crapios',
                    options: [
                        'It is crapi',
                        'It ees crapios',
                        'It is crapios',
                        'Lanus Torvalds'
                    ] 
                }
            ],
            code: '\
<div id="root"></div>\n\
<script src="https://unpkg.com/react@16/umd/react.development.js" crossorigin><\/script>\n\
<script src="https://unpkg.com/react-dom@16/umd/react-dom.development.js" crossorigin><\/script>\n\
<script src="https://unpkg.com/@babel/standalone/babel.min.js"><\/script>\n\
<script type="text/babel">\n\
class SayHello extends React.Component {\n\
    render() {\n\
        return(\n\
            <div>\n\
                Hi {this.props.name}\n\
            </div>\n\
        );\n\
    }\n\
}\n\n\n\
ReactDOM.render(<SayHello name="Rahul"/>, document.getElementById(\'root\'));\n\n',
            editorOptions: {
        // codemirror options
                tabSize: 2,
                mode: 'text/javascript',
                theme: 'base16-dark',
                lineNumbers: true
            }
        }
    }, 

    computed: {
        checkDone: function() {
            var c = 0;
            var t = 0;
            if (this.slug === 'react') {
                for (var key in this.topicCompletedReactArr) {
                    if (this.topicCompletedReactArr[key] === 'true') {
                        c++;
                        t++;
                    } else t++;
                }
            }

            else if (this.slug === 'react-native') {
               for (var key in this.topicCompletedRNArr) {
                    if (this.topicCompletedRNArr[key] === 'true') {
                        c++;
                        t++;
                    } else t++;
                } 
            }

            else if (this.slug === 'ui-design') {
                for (var key in this.topicCompletedUIArr) {
                    if (this.topicCompletedUIArr[key] === 'true') {
                        c++;
                        t++;
                    } else t++;
                } 
            }

            console.log("c is " + c);
            console.log("t is " + t);
            
            if (c === t) {
                return 'true';
            } else return Math.ceil(c*100/t);
        }
    },

    watch: {
        '$route'(to, from) {
            console.log("to is " + to + " and from is " + from);
            if (to.params.topic !== undefined)
            this.showTab(to.params.topic);

            else {

                if (from.path === "/home/learn/react/start-learning/intro-to-react" && to.path === "/home/learn/react/start-learning") {
                    this.$router.back();
                }

                else if (from.path === '/home/learn/react-native/start-learning/intro-to-react-native' && to.path === '/home/learn/react-native/start-learning') {
                    this.$router.back();
                }

                else if (from.path === '/home/learn/ui-design/start-learning/intro-to-ui-design' && to.path === '/home/learn/ui-design/start-learning') {
                    this.$router.back();
                }

                else if (from.path === '/home/learn/vue/start-learning/intro-to-vue' && to.path === '/home/learn/vue/start-learning') {
                    this.$router.back();
                }

                if (to.params.slug === 'react-native') {
                    this.showTab('intro-to-react-native');
                }

                else if (to.params.slug === 'react') {
                    this.showTab('intro-to-react');
                } 

                else if (to.params.slug === 'ui-design') {
                    this.showTab('intro-to-ui-design');
                }

                else if (to.params.slug === 'vue') {
                    this.showTab('intro-to-vue');
                }
            }
        }
    },

    created: function() {
        if (localStorage !== undefined) {
            //React topics
            if (localStorage.getItem('react-intro-to-react'))
                this.topicCompletedReactArr['react-intro-to-react'] = localStorage.getItem('react-intro-to-react');

            if (localStorage.getItem('react-components'))
                this.topicCompletedReactArr['react-components'] = localStorage.getItem('react-components');

            if (localStorage.getItem('react-state-and-lifecycle-methods'))
                this.topicCompletedReactArr['react-state-and-lifecycle-methods'] = localStorage.getItem('react-state-and-lifecycle-methods');

            if (localStorage.getItem('react-events'))
                this.topicCompletedReactArr['react-events'] = localStorage.getItem('react-events');

            if (localStorage.getItem('react-challenge-1'))
                this.topicCompletedReactArr['react-challenge-1'] = localStorage.getItem('react-challenge-1');

            if (localStorage.getItem('react-conditional-rendering'))
                this.topicCompletedReactArr['react-conditional-rendering'] = localStorage.getItem('react-conditional-rendering');

            if (localStorage.getItem('react-keys-and-lists'))
                this.topicCompletedReactArr['react-keys-and-lists'] = localStorage.getItem('react-keys-and-lists');

            if (localStorage.getItem('react-challenge-2'))
                this.topicCompletedReactArr['react-challenge-2'] = localStorage.getItem('react-challenge-2');

            if (localStorage.getItem('react-routing'))
                this.topicCompletedReactArr['react-routing'] = localStorage.getItem('react-routing');

            if (localStorage.getItem('react-real-world-example-1'))
                this.topicCompletedReactArr['react-real-world-example-1'] = localStorage.getItem('react-real-world-example-1');

            if (localStorage.getItem('react-real-world-example-2'))
                this.topicCompletedReactArr['react-real-world-example-2'] = localStorage.getItem('react-real-world-example-2');

            if (localStorage.getItem('react-real-world-example-3'))
                this.topicCompletedReactArr['react-real-world-example-3'] = localStorage.getItem('react-real-world-example-3');

            if (localStorage.getItem('react-real-world-example-4'))
                this.topicCompletedReactArr['react-real-world-example-4'] = localStorage.getItem('react-real-world-example-4');

            if (localStorage.getItem('react-real-world-example-5'))
                this.topicCompletedReactArr['react-real-world-example-5'] = localStorage.getItem('react-real-world-example-5');


            
            //React Native topics
            if (localStorage.getItem('react-native-intro-to-react-native'))
                this.topicCompletedRNArr['react-native-intro-to-react-native'] = localStorage.getItem('react-native-intro-to-react-native');

            if (localStorage.getItem('react-native-jsx-props-and-state'))
                this.topicCompletedRNArr['react-native-jsx-props-and-state'] = localStorage.getItem('react-native-jsx-props-and-state');

            if (localStorage.getItem('react-native-components-and-apis'))
                this.topicCompletedRNArr['react-native-components-and-apis'] = localStorage.getItem('react-native-components-and-apis');

            if (localStorage.getItem('react-native-view-text-and-image'))
                this.topicCompletedRNArr['react-native-view-text-and-image'] = localStorage.getItem('react-native-view-text-and-image');

            if (localStorage.getItem('react-native-style-and-flexbox'))
                this.topicCompletedRNArr['react-native-style-and-flexbox'] = localStorage.getItem('react-native-style-and-flexbox');

            if (localStorage.getItem('react-native-scrollview-and-listviews'))
                this.topicCompletedRNArr['react-native-scrollview-and-listviews'] = localStorage.getItem('react-native-scrollview-and-listviews');

            if (localStorage.getItem('react-native-routing'))
                this.topicCompletedRNArr['react-native-routing'] = localStorage.getItem('react-native-routing');

            if (localStorage.getItem('react-native-networking-apis'))
                this.topicCompletedRNArr['react-native-networking-apis'] = localStorage.getItem('react-native-networking-apis');


            if (localStorage.getItem('react-native-real-world-example-1'))
                this.topicCompletedReactArr['react-native-real-world-example-1'] = localStorage.getItem('react-native-real-world-example-1');

            if (localStorage.getItem('react-native-real-world-example-2'))
                this.topicCompletedReactArr['react-native-real-world-example-2'] = localStorage.getItem('react-native-real-world-example-2');

            if (localStorage.getItem('react-native-real-world-example-3'))
                this.topicCompletedReactArr['react-native-real-world-example-3'] = localStorage.getItem('rreact-native-real-world-example-3');

            if (localStorage.getItem('react-native-real-world-example-4'))
                this.topicCompletedReactArr['react-native-real-world-example-4'] = localStorage.getItem('react-native-real-world-example-4');

            if (localStorage.getItem('react-native-real-world-example-5'))
                this.topicCompletedReactArr['react-native-real-world-example-5'] = localStorage.getItem('react-native-real-world-example-5');



            //UI Design topics
            if (localStorage.getItem('ui-design-intro-to-ui-design'))
                this.topicCompletedUIArr['ui-design-intro-to-ui-design'] = localStorage.getItem('ui-design-intro-to-ui-design');

            if (localStorage.getItem('ui-design-simplicity-over-complexity'))
                this.topicCompletedUIArr['ui-design-simplicity-over-complexity'] = localStorage.getItem('ui-design-simplicity-over-complexity');

            if (localStorage.getItem('ui-design-outcomes-over-features'))
                this.topicCompletedUIArr['ui-design-outcomes-over-features'] = localStorage.getItem('ui-design-outcomes-over-features');

            if (localStorage.getItem('ui-design-visual-hierarchy'))
                this.topicCompletedUIArr['ui-design-visual-hierarchy'] = localStorage.getItem('ui-design-visual-hierarchy');

            if (localStorage.getItem('ui-design-alignment'))
                this.topicCompletedUIArr['ui-design-alignment'] = localStorage.getItem('ui-design-alignment');

            if (localStorage.getItem('ui-design-focal-points'))
                this.topicCompletedUIArr['ui-design-focal-points'] = localStorage.getItem('ui-design-focal-points');

            if (localStorage.getItem('ui-design-contrast'))
                this.topicCompletedUIArr['ui-design-contrast'] = localStorage.getItem('ui-design-contrast');

            if (localStorage.getItem('ui-design-dominance'))
                this.topicCompletedUIArr['ui-design-dominance'] = localStorage.getItem('ui-design-dominance');

            if (localStorage.getItem('ui-design-rythm'))
                this.topicCompletedUIArr['ui-design-rythm'] = localStorage.getItem('ui-design-rythm');

            
            //Modern JavaScript topics
            if (localStorage.getItem('modern-javascript-intro-to-modern-javascript'))
                this.topicCompletedJSArr['modern-javascript-intro-to-modern-javascript'] = localStorage.getItem('modern-javascript-intro-to-modern-javascript');
                
            if (localStorage.getItem('modern-javascript-basic-concepts'))
                this.topicCompletedJSArr['modern-javascript-basic-concepts'] = localStorage.getItem('modern-javascript-basic-concepts');

            if (localStorage.getItem('modern-javascript-data-types'))
                this.topicCompletedJSArr['modern-javascript-data-types'] = localStorage.getItem('modern-javascript-data-types');


            //Vue topics
            if (localStorage.getItem('vue-intro-to-vue'))
                this.topicCompletedVueArr['vue-intro-to-vue'] = localStorage.getItem('vue-intro-to-vue');    
        }


    },




    mounted: function() {

        //initialise course contents
        this.courses.modern_javascript = ModernJavaScript;
        this.courses.react = React;
        this.courses.react_native = ReactNative;
        this.courses.ui_design = UIDesign;
        this.courses.vue = VueJS;

        //set next topic for each topic
        this.nextTopicTable['react-native-jsx-props-and-state'] = 'components';
        this.nextTopicTable['react-native-components'] = 'view-text-and-image';
        this.nextTopicTable['react-intro-to-react'] = 'components';
        this.nextTopicTable['react-components'] = 'state-and-lifecycle-methods';
        this.nextTopicTable['react-state-and-lifecycle-methods'] = 'events';
        this.nextTopicTable['react-events'] = 'challenge-1';
        this.nextTopicTable['react-challenge-1'] = 'conditional-rendering';
        this.nextTopicTable['react-conditional-rendering'] = 'keys-and-lists';
        this.nextTopicTable['react-keys-and-lists'] = 'routing';
        this.nextTopicTable['react-routing'] = 'challenge-2';
        this.nextTopicTable['react-challenge-2'] = 'real-world-example-1';
        this.nextTopicTable['react-real-world-example-1'] = 'real-world-example-2';
        this.nextTopicTable['react-real-world-example-2'] = 'real-world-example-3';
        this.nextTopicTable['react-real-world-example-3'] = 'real-world-example-4';
        this.nextTopicTable['react-real-world-example-4'] = 'real-world-example-5';


        this.nextTopicTable['react-native-intro-to-react-native'] = 'jsx-props-and-state';
        this.nextTopicTable['react-native-jsx-props-and-state'] = 'components-and-apis';
        this.nextTopicTable['react-native-components-and-apis'] = 'view-text-and-image';
        this.nextTopicTable['react-native-view-text-and-image'] = 'style-and-flexbox';
        this.nextTopicTable['react-native-style-and-flexbox'] = 'scrollview-and-listviews';
        this.nextTopicTable['react-native-scrollview-and-listviews'] = 'routing';
        this.nextTopicTable['react-native-routing'] = 'networking-apis';
        this.nextTopicTable['react-native-networking-apis'] = 'real-world-example-1';
        this.nextTopicTable['react-native-real-world-example-1'] = 'real-world-example-2';
        this.nextTopicTable['react-native-real-world-example-2'] = 'real-world-example-3';
        this.nextTopicTable['react-native-real-world-example-3'] = 'real-world-example-4';
        this.nextTopicTable['react-native-real-world-example-4'] = 'real-world-example-5';


        this.nextTopicTable['ui-design-intro-to-ui-design'] = 'simplicity-over-complexity';
        this.nextTopicTable['ui-design-simplicity-over-complexity'] = 'outcomes-over-features';
        this.nextTopicTable['ui-design-outcomes-over-features'] = 'visual-hierarchy';
        this.nextTopicTable['ui-design-visual-hierarchy'] = 'alignment';
        this.nextTopicTable['ui-design-alignment'] = 'focal-points';
        this.nextTopicTable['ui-design-focal-points'] = 'contrast';
        this.nextTopicTable['ui-design-contrast'] = 'dominance';
        this.nextTopicTable['ui-design-dominance'] = 'rythm';

        var mycodeinitial = "\
import React, { Component } from 'react';#~\
import { AppRegistry, Image } from 'react-native';#~\
export default class Bananas extends Component {#~\
    render() {#~\
        let pic = {#~\
            uri: 'https://upload.wikimedia.org/wikipedia/commons/d/de/Bananavarieties.jpg'#~\
        };#~\
        return (#~\
        <Image source={pic} style={{width: 193, height: 110}}/>#~\
        );#~\
    }#~\
}#~\
#~\
// skip this line if using Create React Native App#~\
AppRegistry.registerComponent('AwesomeProject', () => Bananas);#~\
";
        

        if (this.$route.params.slug === 'react') {
            mixpanel.track("started learning react", {
                "learning_module": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            this.showTab('intro-to-react');
        }
        else if (this.$route.params.slug === 'react-native') {
            mixpanel.track("started learning react native", {
                "learning_module": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            this.showTab('intro-to-react-native');
        }
        else if(this.$route.params.slug === 'ui-design') {
            mixpanel.track("started learning ui design", {
                "learning_module": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            this.showTab('intro-to-ui-design');
        }

        else if(this.$route.params.slug === 'vue') {
            mixpanel.track("started learning vuejs", {
                "learning_module": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            this.showTab('intro-to-vue');
        }

    },
    methods: {
        showTab: function(show_topic) {
            this.showDefault = false;
            window.scrollTo(0,0);
            this.topic = show_topic;
            mixpanel.track("learning topic " + show_topic, {
                "topic": show_topic,
                "learning_module": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            
            this.$router.push('/home/learn/' + this.$route.params.slug + '/start-learning/' + show_topic);   
        },
        getSlug: function() {
            return this.$route.params.slug;
        },
        onCmCodeChange(newCode) {
            this.code = newCode;
        },
        handleAnimation: function(anim) {
            this.anim = anim;
        },
        submitCode() {
            //document.getElementById('output-iframe').contentDocument.write(this.code);
        },
        showQuestions() {
            this.showQuiz = true;
        },
        setCompleted(slug_topic) {
            localStorage.setItem(slug_topic, "true");
            console.log("inside setCompleted of setLearning, slug_topic is " + slug_topic);

            if (this.slug === 'react')
                this.topicCompletedReactArr[slug_topic] = "true";

            else if (this.slug === 'react-native')
                this.topicCompletedRNArr[slug_topic] = "true";

            else if (this.slug === 'ui-design')
                this.topicCompletedUIArr[slug_topic] = "true";
           
        },  
        goToNextTopic() {
            this.showTab(this.nextTopicTable[this.$route.params.slug + '-' + this.topic]);
        },
        setAttempted(slug_topic, score) {
            localStorage.setItem(slug_topic, score);
            console.log("inside setAttempted of setLearning, slug_topic is " + slug_topic + " score is " + score);
            
            if (this.slug === 'react')
                this.topicCompletedReactArr[slug_topic] = score;

            else if (this.slug === 'react-native')
                this.topicCompletedRNArr[slug_topic] = score;
            
            
        },
        exec() {
            var idoc = document.getElementById('output-iframe').contentWindow.document;
            idoc.open();
            idoc.write(
                this.code
            );
            idoc.close();
            document.getElementById('output-iframe').contentWindow.onerror = function(errorMsg, url, lineNumber) {
                alert(errorMsg + lineNumber);
            }
        },
        feedbackOnCompletion() {
            mixpanel.track("course completed " + this.$route.params.slug, {
                "learning_module": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            this.showFeedback = true;
        },
        feedbackOnNonCompletion() {
            mixpanel.track("course not completed " + this.$route.params.slug, {
                "learning_module": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            this.showFeedback = true;
        },
        modalSubmittedUI() {
            mixpanel.track("feedback received UI", {
                "user_rating": this.feedbackUIrating,
                "user_text": this.feedbackUItext
            });
        },
        modalSubmittedReact() {
            mixpanel.track("feedback received React", {
                "user_rating": this.feedbackReactrating,
                "user_text": this.feedbackReacttext
            });
        },
        modalSubmittedRN() {
            mixpanel.track("feedback received RN", {
                "user_rating": this.feedbackRNrating,
                "user_text": this.feedbackRNtext
            });
        },
        switchArrow() {
            this.left = !this.left;
            this.right = !this.right;
        }

    }
}
</script>


<style scoped>

.start-div {
    background-color: #fff;
}

.code-embed {
    width: 80%;
    height: 80%;
}

.heading {
    font-size: 1.55rem;
    margin-left: 2%;
    margin-bottom: 2%;
}

.category-heading {
    font-size: 1.55rem;
}

.dashboard-content-learning {
    padding-top: 5%;
    padding-bottom: 2%;
}

.card {
    border:none;
    box-shadow: 2px 1px 2px 0px rgba(1, 2, 2, 0.15);
    transition: all 0.3s ease;
    font-family: Helvetica;
    cursor:pointer;
    border-radius: 10px;
    color: #444;
    font-size: 0.98em;
    line-height: 1.6em;
    padding-top: 2%;
    padding-bottom: 2%;
    margin-bottom: 4%;
    margin-top: 3%;
    padding-left: 5%;
    padding-right: 5%;
}

.content {
    padding: 3% 6%;
    margin: 0% 0;
}

.nav-tabs {
    border-radius: 10px;
    background-color: #fff;
    border: solid 1px #fff;
}

.nav-item {
    background-color: #fff;
    color: #555;
    padding-top: 2%;
    padding-bottom: 2%;
    border-bottom: solid 0.5px #fafafa;
}

.nav-link {
    color: #555;
}

.chapter-group {
    display: block;
    background-color: #fff;
    padding-left: 8%;
    padding-right: 8%;
    padding-top: 6%;
    padding-bottom: 6%;
    border-bottom: 0.5px solid #eee;
    cursor: pointer;
}

.chapter-heading {
    display: block;
    background-color: #fff;
    font-size: 0.9rem;
    padding-left: 8%;
    padding-right: 8%;
    padding-top: 9%;
    padding-bottom: 7%;
    border-bottom: 0.5px solid #eee;
}

.chapter-group:hover {
    background-color: #fafafa;
}

.table-outline {
    margin-top: 1.8%;
    box-shadow: 2px 1px 2px 0px rgba(1, 2, 2, 0.15);
    border-radius: 4px;
}

.col-sm-4 .col-sm-8 {
    padding-left: 0px;
    padding-right: 0px;
}

@media (min-width: 800px) {
    #category-table-react {
        padding-left: 0px;
        padding-right: 0px;
        height: 100%;
        top: 50px;
        z-index: 10;
        position: sticky;
    }

    #category-table-rn {
        padding-left: 0px;
        padding-right: 0px;
        height: 100%;
        position: sticky;
        top: 50px;
    }

    #category-table-ui {
        padding-left: 0px;
        padding-right: 0px;
        height: 100%;
        position: sticky;
        top: 50px;
    }

    #category-table-modern-js {
        padding-left: 0px;
        padding-right: 0px;
        height: 100%;
        position: sticky;
        top: 50px;
    }

}

@media (max-width: 799px) {
    #category-table {
        padding-left: 0px;
        padding-right: 0px;
        height: 100%;
    }
}



.completion-rate {
    font-size: 0.8rem;
    color: #999;
}

.title {
    float: left;
}

.arrow {
    float:right;
}

.fa {
    float: right;
    color: #222;
    margin-top: 3.6%;
    font-size: 1rem;
}

.content-card {
    margin-top: 2%;
}

:target {
    display: block
}

.a {
    color: #555;
    text-decoration: none;
}

.lottie-anim {
    margin: 0px !important;
}

.click-tab {
    text-decoration: none;
    color: #555;
}


code {
    color: #6c6fcc;
}

.completed-tick {
    height: 32px;
    width: 32px;
    margin-left: -4%;
    margin-right: 10px;
    margin-bottom: 1.8%;
}

.not-completed-tick {
    height: 32px;
    width: 32px;
    margin-right: 2px;
    margin-left: -1.4%;
    margin-top:2%;
    margin-bottom:-1%;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s ease;
}
.slide-fade-enter, .slide-fade-leave
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(2px);
  opacity: 0;
}


.right-check {
    width: 100%;
}

</style>
